// extracted by mini-css-extract-plugin
export default {"button":"CTAButton_button__TjpzH"};